import { usePostHog } from "posthog-js/react";
import { useEffect, useState } from "react";
import {
  fetchDeployedAppVersion,
  getRunningAppVersion,
  isNewerVersion,
} from "./appVersion";
import { registerSelfReloadingScreen } from "./selfReloadingScreens";

export const useReloadOnNewAppVersion = () => {
  const postHog = usePostHog();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => registerSelfReloadingScreen(), []);

  useEffect(() => {
    let screenMounted = true;

    fetchDeployedAppVersion()
      .then(deployedVersion => {
        if (!screenMounted) {
          return;
        }
        if (isNewerVersion(deployedVersion, getRunningAppVersion())) {
          postHog.capture("app_update", {
            newVersion: deployedVersion,
            oldVersion: getRunningAppVersion(),
            automaticReload: true,
          });
          window.location.reload();
          return;
        }
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        console.error(e);
      });

    return () => {
      screenMounted = false;
    };
  }, [postHog]);

  return {
    loading: loading,
  };
};
